import { ConfigService, 
         CookiesHelper,
         EventBus, 
         SessionEntity}             from '..';

/**
 * The service that implements the functions related to initialization process.
 */
export class BotInitializationService {

    public static timeoutPolling : any;

    /**
     * Generates a unique guest identifier for a conversation session.
     */
    public static generateGuestId() {
        const guestId: string = 'anonymous-'.concat(Date.now()+'', Math.random()+''.substring(2));
        CookiesHelper.setCookie('userId', guestId);
        return guestId;
    }

    public static stopNotificationPolling(){
        clearTimeout(this.timeoutPolling)
    }
    
    /**
     * Init the polling loop to fetch notification data recursively
     * @param dispatch the dispatch method to call the action which fetch notification data
     * @param sessionInfo the params to the request to fetch notification data
     */
    public static async initNotificationPolling(dispatch: any, sessionInfo : SessionEntity){
        dispatch('messages/sendNotificationCommand', { sessionInfo }, { root: true })
        setTimeout(() => dispatch('messages/requestMessageAnswer', { sessionInfo, isRetry: false, remainingRetries: 0}, { root: true }), 3000); // for the first pull, to let the server the time to fetch notifications for the session
        // if the polling is already running, stop it before starting a new one
        this.stopNotificationPolling();
        this.timeoutPolling = setTimeout(() => BotInitializationService.initNotificationPolling(dispatch,sessionInfo), ConfigService.getNotificationPollingPeriod());
    }

    /**
     * Retrieves the unique guest identifier for a conversation session, it could be found in a cookie otherwise generated.
     * 
     * @param userIdParam - The user id configured from administration app
     */
    public static retrieveGuestId(userIdParam?: string): string {
        let guestId: string | undefined = ConfigService.getConfiguredGuestId();
        if (guestId) {
            return guestId;
        } else if (userIdParam && userIdParam !== '-1') {
            // if integration script has not provided explicitly a guest identifier then 
            // verify if it has configured in administration app
            return userIdParam;
        } else {
            guestId = CookiesHelper.getCookie('userId');
            if (!guestId || guestId === '-1') {
                guestId = BotInitializationService.generateGuestId();
            }
            return guestId;
        }
    }

    public static handleAdminAppMessage(event: any) {
        // const originUrl: string = window.serverConfig.botRoot;
        // if (originUrl.indexOf(event.origin) !== -1 && event.data && event.data.authData) {
        if (event.data && event.data.authData) {
            const faqId: string = event.data.authData['faqId'];
            const botKey: string = event.data.authData['botKey'];
            const botName: string = event.data.authData['botName'];
            
            if (faqId && botKey && botName) {
                if (event.data.authData['isEmbedded'] !== undefined) {
                    ConfigService.setWidgetMode(event.data.authData['isEmbedded']);
                }
                ConfigService.setBotCredentials(faqId, botKey, botName, event.data.authData['roleValue']);
                EventBus.$emit('ADMIN_INIT_READY_EVENT');
            }
        }
        // }
    }

    /**
     * Create a new style tag with CSS rules for one item of the DOM
     * 
     * @param idOrClassName - Element on which CSS will be apply
     * @param cssRules - All the CSS rules
     */
    public static addStyleRuleInDOM(idOrClassName:string, cssRules:string) {
        document.head.insertAdjacentHTML("beforeend", `<style>${idOrClassName}{${cssRules}}</style>`)
    }
  

    /**
     * Add or remove a class from multiple HTML elements
     * 
     * @param toggleSynapseClassInDOM - Boolean that tells if a class is active or not
     * @param htmlTagIdOrClass - The targeted HTML element's tag, id or class
     * @param synapseClassName - The class to toggle in the DOM
     */
    public static toggleSynapseClassInDOM(toggleSynapseClassInDOM: boolean, htmlTagIdOrClass: string | undefined, synapseClassName: string | undefined) {

        if (htmlTagIdOrClass === undefined || synapseClassName === undefined)
            return;

        const htmlElementByTag: HTMLCollectionOf<Element> = document.getElementsByTagName(htmlTagIdOrClass);
        if(htmlElementByTag.length !== 0)
            for (const element of htmlElementByTag) {
                if (toggleSynapseClassInDOM) {
                    element.classList.add(synapseClassName);
                } else {
                    element.classList.remove(synapseClassName);
                }
            }

        const htmlElementById: HTMLElement | null = document.getElementById(htmlTagIdOrClass);
        if (htmlElementById !== null) {
            (toggleSynapseClassInDOM ? htmlElementById.classList.add(synapseClassName) : htmlElementById.classList.remove(synapseClassName));
        }

        const htmlElementsByClass: HTMLCollectionOf<Element> = document.getElementsByClassName(htmlTagIdOrClass);
        if(htmlElementsByClass.length !== 0)
            for (const element of htmlElementsByClass) {
                if (toggleSynapseClassInDOM) {
                    element.classList.add(synapseClassName);
                } else {
                    element.classList.remove(synapseClassName);
                }
            }
    }
}
